module.exports = __webpack_public_path__ + "static/img/lisa.3c08ef5a.jpg";